<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div>
            <h1 class="banner-title">BIỂU ĐỒ SỐ LƯỢNG GIAO DỊCH</h1>
            <p class="banner-subtitle">Phân tích tần suất và số lượng giao dịch biến động theo thời gian, hỗ trợ xuất báo cáo thống kê.</p>
          </div>
        </div>
        <div class="banner-actions">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-download" @click="handleCommand('exportExcel')">
            Xuất Excel Thống Kê
          </el-button>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-chat-line-square"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng giao dịch ghi nhận</p>
          <h3 class="stat-value">{{ totalTransactions }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Giao dịch tiền vào (Credit)</p>
          <h3 class="stat-value">{{ totalMoneyInTransactions }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-circle-close"></i></div>
        <div class="stat-info">
          <p class="stat-label">Giao dịch tiền ra (Debit)</p>
          <h3 class="stat-value">{{ totalMoneyOutTransactions }}</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataSearch" class="modern-filter-form">
        <!-- Chế độ xem -->
        <el-form-item label="Chế độ xem">
          <el-radio-group v-model="dataSearch.type" @change="changeTypeMethod" class="modern-radio-group">
            <el-radio-button label="day">Theo ngày</el-radio-button>
            <el-radio-button label="year">Theo năm</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <!-- Picker thời gian -->
        <el-form-item label="Khoảng ngày" v-if="dataSearch.type === 'day'">
          <el-date-picker
            v-model="times"
            type="daterange"
            format="dd-MM-yyyy"
            unlink-panels
            :clearable="false"
            range-separator="-"
            start-placeholder="Bắt đầu"
            end-placeholder="Kết thúc"
            class="modern-date-picker"
            @change="changleData"
          />
        </el-form-item>

        <el-form-item label="Chọn năm" v-if="dataSearch.type === 'year'">
          <el-date-picker
            v-model="dataSearch.year"
            type="year"
            format="yyyy"
            :clearable="false"
            placeholder="Chọn năm"
            class="modern-date-picker-year"
            @change="changleData"
          />
        </el-form-item>

        <!-- Trường học -->
        <el-form-item label="Trường học">
          <el-select
            v-model="dataSearch.idSchool"
            filterable
            clearable
            placeholder="Tất cả các trường"
            class="modern-select school-select"
            @change="changleData"
          >
            <el-option
              v-for="item in schoolList"
              :key="item.id"
              :value="item.id"
              :label="`${item.id} - ${item.schoolName}`"
            />
          </el-select>
        </el-form-item>

        <!-- Loại giao dịch -->
        <el-form-item label="Loại giao dịch">
          <el-select
            v-model="dataSearch.transferType"
            filterable
            clearable
            placeholder="Tất cả loại"
            class="modern-select"
            @change="changleData"
          >
            <el-option
              v-for="item in transferTypeList"
              :key="item.id"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <!-- Thuộc tính học sinh -->
        <el-form-item label="Phân loại GD">
          <el-select
            v-model="dataSearch.belongOnekids"
            class="modern-select"
            @change="changleData"
          >
            <el-option
              v-for="item in belongOnekidsList"
              :key="item.id"
              :value="item.value"
              :label="item.label"
            />
          </el-select>
        </el-form-item>

        <!-- Số tài khoản -->
        <el-form-item label="Số tài khoản">
          <el-input
            v-model="dataSearch.accountNumber"
            clearable
            placeholder="Số tài khoản..."
            class="modern-input"
            prefix-icon="el-icon-bank"
            @keyup.enter.native="changleData"
            @clear="changleData"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="changleData">Lọc biểu đồ</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Chart Block -->
    <div class="glass-card chart-container-card">
      <spinner-custom v-if="loadTransactionVolumeChartDB"/>
      <div v-else class="chart-wrapper">
        <ChartBar
          :key="dataSearch.type"
          v-if="showChartDB"
          :checkLable="true"
          :chartData="dataTransactionVolumeChartDB.chartData"
          :options="dataTransactionVolumeChartDB.options"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ChartBar from "@/views/chartStatistical/chart/ChartBar.vue";
import moment from "moment";
import sePayConnectionService from "@/services/SePayConnectionService";
import systemConfigService from "@/services/AdminService/SystemConfigService";
import { exportToExcelStatistics } from "@/commonFuncion/ExportExcelTransactionVolume";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "TransactionVolumeChart",
  components: { ChartBar },
  data() {
    return {
      loadTransactionVolumeChartDB: false,
      showChartDB: true,
      dataTransactionVolumeChartDB: {},
      dataListDB1: [],
      dataListDB2: [],
      dataListDB3: [],
      listDay: [],
      belongOnekidsList: [
        { id: 1, value: true, label: "Trong trường" },
        { id: 2, value: false, label: "Ngoài trường" }
      ],
      dataSearch: {
        type: "day",
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        transferType: "",
        accountNumber: "",
        year: moment().format("YYYY-MM-DD"),
        idSchool: "",
        belongOnekids: true
      },
      times: [],
      schoolList: [],
      transferTypeList: [
        { id: 1, value: "credit", label: "Tiền vào" },
        { id: 2, value: "debit", label: "Tiền ra" }
      ],
      exportToExcelData: {
        titleFile: "THỐNG KÊ SỐ LƯỢNG GIAO DỊCH",
        columnWidths: [10, 30, 30, 30, 30],
        nameFile: "Thong_ke_so_luong_giao_dich_" + moment().format("DD-MM-YYYY_hh-mm-ss")
      },
      listData: []
    };
  },

  computed: {
    totalTransactions() {
      if (!this.dataListDB1 || this.dataListDB1.length === 0) return 0;
      return this.dataListDB1.reduce((a, b) => a + (Number(b) || 0), 0);
    },

    totalMoneyInTransactions() {
      if (!this.dataListDB2 || this.dataListDB2.length === 0) return 0;
      return this.dataListDB2.reduce((a, b) => a + (Number(b) || 0), 0);
    },

    totalMoneyOutTransactions() {
      if (!this.dataListDB3 || this.dataListDB3.length === 0) return 0;
      return this.dataListDB3.reduce((a, b) => a + (Number(b) || 0), 0);
    },

    titleFileWithDateRange() {
      const start = moment(this.dataSearch.startDate).format("DD-MM-YYYY");
      const end = moment(this.dataSearch.endDate).format("DD-MM-YYYY");
      return `THỐNG KÊ SỐ LƯỢNG GIAO DỊCH TỪ ${start} ĐẾN ${end}`;
    },
    
    completeExportToExcelData() {
      return {
        ...this.exportToExcelData,
        companyInfo: []
      };
    }
  },

  async mounted() {
    const today = moment().format("YYYY-MM-DD");
    const tenDaysAgo = moment().subtract(10, "days").format("YYYY-MM-DD");
    this.dataSearch.startDate = tenDaysAgo;
    this.dataSearch.endDate = today;
    this.times = [this.dataSearch.startDate, this.dataSearch.endDate];
    this.dataSearch.year = new Date();
    await this.findAllData();
    this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate);
    await this.fillDataDB();
    this.findAllAppIconForSchool();
  },

  methods: {
    exportToExcelStatistics,
    async findAllAppIconForSchool() {
      try {
        const resp = await systemConfigService.findSchoolConfig("", this.dataSearch.idSchool, true);
        if (this.dataSearch.idSchool === "") {
          this.schoolList = resp.data.data || [];
        }
      } catch (err) {
        console.error(err);
      }
    },

    async changeTypeMethod() {
      this.loadTransactionVolumeChartDB = true;
      if (this.dataSearch.type === "day") {
        this.dataSearch.year = "";
        this.dataSearch.startDate = moment(this.times[0]).format("YYYY-MM-DD");
        this.dataSearch.endDate = moment(this.times[1]).format("YYYY-MM-DD");
        this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate);
        await this.findAllData();
      }
      if (this.dataSearch.type === "year") {
        this.dataSearch.year = new Date();
        this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate);
        await this.findAllData();
      }
      await this.fillDataDB();
      this.loadTransactionVolumeChartDB = false;
    },

    async changleData() {
      this.loadTransactionVolumeChartDB = true;
      await this.findAllData();
      this.generateDataLists(this.dataSearch.startDate, this.dataSearch.endDate);
      await this.fillDataDB();
      this.loadTransactionVolumeChartDB = false;
    },

    async findAllData() {
      this.resetList();
      if (this.dataSearch.type === "day") {
        this.dataSearch.year = "";
      }
      if (this.times && this.times.length === 2) {
        this.dataSearch.startDate = moment(this.times[0]).format("YYYY-MM-DD");
        this.dataSearch.endDate = moment(this.times[1]).format("YYYY-MM-DD");
      }
      const yearValue = this.dataSearch.year ? moment(this.dataSearch.year).format("YYYY") : "";
      try {
        const res = await sePayConnectionService.getTotalTransactionForAdmin(
          this.dataSearch.startDate,
          this.dataSearch.endDate,
          this.dataSearch.transferType,
          this.dataSearch.accountNumber,
          yearValue,
          this.dataSearch.idSchool,
          this.dataSearch.belongOnekids
        );
        this.dataListDB1 = res.data.data.totalTransactionList || [];
        this.dataListDB2 = res.data.data.totalTransactionMoneyInList || [];
        this.dataListDB3 = res.data.data.totalTransactionMoneyOutList || [];
      } catch (err) {
        console.error(err);
      }
    },

    generateDataLists(startDate, endDate) {
      this.listDay = [];
      if (this.dataSearch.type === "day") {
        let current = moment(startDate);
        const end = moment(endDate);
        while (current.isSameOrBefore(end)) {
          this.listDay.push(current.format("DD-MM-YYYY"));
          current.add(1, "day");
        }
      } else {
        this.listDay = this.$funcData.getListMonth();
      }
    },

    resetList() {
      this.dataListDB1 = [];
      this.dataListDB2 = [];
      this.dataListDB3 = [];
    },

    handleCommand(command) {
      if (command === "exportExcel") {
        this.getExcelData();
        this.handleExportExcel();
      }
    },

    async fillDataDB() {
      this.dataTransactionVolumeChartDB = {
        chartData: {
          labels: this.listDay,
          datasets: [
            {
              label: "Tổng số giao dịch",
              data: this.dataListDB1,
              backgroundColor: "#6aa5e3"
            },
            {
              label: "Tổng số giao dịch tiền vào",
              data: this.dataListDB2,
              backgroundColor: "#34e527"
            },
            {
              label: "Tổng số giao dịch tiền ra",
              data: this.dataListDB3,
              backgroundColor: "#ac20f8"
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: true,
            text: "Tổng hợp số lượng giao dịch hệ thống ghi nhận",
            fontSize: 18,
            fontColor: "#1e293b",
            fontFamily: "Outfit, Inter, sans-serif"
          },
          plugins: {
            datalabels: {
              color: "#334155",
              anchor: (ctx) => (ctx.datasetIndex === 0 ? "end" : ctx.dataset.data[ctx.dataIndex] > 0 ? "end" : "start"),
              align: (ctx) => (ctx.datasetIndex === 0 ? "end" : ctx.dataset.data[ctx.dataIndex] > 0 ? "end" : "start"),
              formatter: (value) => (value !== 0 ? value.toLocaleString() : "")
            }
          },
          scales: {
            yAxes: [
              {
                display: true,
                ticks: {
                  callback: (value) => ` ${value.toLocaleString()}`
                }
              }
            ]
          }
        }
      };
    },

    async handleExportExcel() {
      const title = this.titleFileWithDateRange;
      const fileName = this.exportToExcelData.nameFile;
      this.exportToExcelData.titleFile = title;
      this.exportToExcelData.nameFile = fileName;
      if (this.listData.length > 0) {
        this.$confirm("Bạn có chắc chắn muốn xuất file hiện tại?", "Thông báo!", {
          confirmButtonText: "Có",
          cancelButtonText: "Không",
          type: "warning"
        }).then(async () => {
          await this.exportToExcelStatistics(this.completeExportToExcelData, this.listData, this.dataSearch.type).then(() => {
            this.$message({
              message: "Xuất file thành công!",
              type: "success",
              duration: 5000
            });
          });
        });
      } else {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu!");
      }
    },

    getExcelData() {
      this.listData = [];
      if (this.listDay.length > 0) {
        for (let i = 0; i < this.listDay.length; i++) {
          let object = {
            label: this.listDay[i],
            totalTransactionMoneyIn: this.dataListDB2[i] || 0,
            totalTransactionMoneyOut: this.dataListDB3[i] || 0,
            totalTransaction: this.dataListDB1[i] || 0
          };
          this.listData.push(object);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-radio-group {
    /deep/ .el-radio-button__inner {
      font-weight: 600;
    }
  }

  .modern-date-picker {
    width: 250px;
  }

  .modern-date-picker-year {
    width: 120px;
  }

  .modern-select {
    width: 175px;

    &.school-select {
      width: 250px;
    }
  }

  .modern-input {
    width: 200px;
  }
}

.chart-container-card {
  background: #fff;
  padding: 24px;
}

.chart-wrapper {
  height: 500px;
  position: relative;
}

.mb-4 { margin-bottom: 16px; }
</style>